var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 368.111,
    height: 394.614,
    viewBox: "0 0 368.111 394.614",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "leaf 8",
    d: "M147.501 54.137C170.875 56.0176 173.993 0 173.993 0C173.993 0 183.707 67.8835 208.343 58.4228C222.88 52.8403 230.345 25.0384 230.345 25.0384C228.328 77.981 217.133 156.974 225.181 160.606C233.229 164.239 253.245 130.38 253.245 130.38L281.981 80.7543C281.981 80.7543 284.451 92.9351 289.39 96.7698C294.329 100.605 351.354 80.7543 351.354 80.7543C351.354 80.7543 325.087 126.094 342.374 130.38C359.661 134.666 367.968 130.38 367.968 130.38C371.129 132.166 320.821 184.066 320.821 184.066C320.821 184.066 272.331 213.022 259.096 220.324C271.89 218.101 308.95 240.297 301.289 244.293C301.289 244.293 274.573 240.91 273.45 244.293C272.328 247.677 303.085 272.715 303.085 272.715C303.085 272.715 262.674 278.129 260.653 284.445C258.633 290.761 271.654 307.453 271.654 307.453C271.654 307.453 222.319 279.012 185.219 278.072C185.219 278.072 187.235 349.616 185.219 360.011C183.202 370.406 180.953 375.801 180.953 375.801C180.953 375.801 167.707 398.358 158.278 394.072C148.848 389.786 170.026 368.894 173.993 352.567C180.824 324.454 175.34 278.532 175.34 278.532C139.455 282.811 93.8442 314.446 93.8442 314.446C93.8442 314.446 105.07 290.31 99.4568 287.377C93.8442 284.445 56.5759 292.34 56.5759 292.34C56.5759 292.34 77.2306 260.76 76.1081 256.474C74.9855 252.188 53.2083 252.188 53.2083 252.188C53.2083 252.188 89.5785 225.345 85.5374 223.315C81.4962 221.285 42.0321 203.258 23.5733 180.231C11.2479 164.855 0 135.568 0 135.568C0 135.568 19.744 142.153 28.9615 135.568C44.1459 124.72 14.144 90.0027 14.144 90.0027C14.144 90.0027 50.631 120.947 67.8013 107.146C75.3761 101.058 80.1492 85.4913 80.1492 85.4913C90.5251 122.171 101.775 140.912 130.888 171.208C133.251 116.784 130.472 86.3164 119.438 32.031C119.438 32.031 133.62 53.02 147.501 54.137Z",
    fill: "url(#paint0_linear_0_57)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_57",
    x1: 184.055,
    y1: 0,
    x2: 184.055,
    y2: 394.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafC);
export default __webpack_public_path__ + "static/media/leaf-c.744287f203142683f304c3a24c2710ee.svg";
export { ForwardRef as ReactComponent };